/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Carousel, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function NoteCarouselPreview({ srcs, redirectUrl }) {
  const [showSecondImage, setShowSecondImage] = useState(false)
  const containerRef = useRef(null)
  const [showSmallImage, setShowSmallImage] = useState(true)

  const firstImage = srcs.length > 0 ? srcs[0] : null
  const carouselImages = srcs.length > 1 ? srcs.slice(1) : []

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
        {firstImage?.file && showSmallImage && !showSecondImage && (
          <div style={{ position: 'absolute', bottom: '6%' }}>
            <Image
              className="d-flex"
              src={
                firstImage.file instanceof File ||
                firstImage.file instanceof Blob
                  ? URL.createObjectURL(firstImage.file)
                  : firstImage.file
              }
              alt={firstImage.label}
              onClick={() => {
                setShowSmallImage(false)
                setShowSecondImage(true)
              }}
              style={{
                position: 'sticky',
                objectFit: 'cover',
                borderRadius: '50%',
                height: '4rem',
                width: '4rem',
                cursor: 'pointer',
                marginLeft: '1rem',
              }}
            />
            <Button
              onClick={() => setShowSmallImage(false)}
              style={{
                position: 'absolute',
                top: '-10px',
                left: '3%',
                background: 'rgba(0, 0, 0, 0.5)',
                border: 'none',
                color: 'white',
                borderRadius: '50%',
                width: '16px',
                height: '16px',
                fontSize: '10px',
                cursor: 'pointer',
                padding: 0,
                zIndex: 1501,
              }}
            >
              ✕
            </Button>
          </div>
        )}
        {showSecondImage && (
          <>
            <Carousel
              className="mx-auto position-absolute"
              style={{
                width: '22%',
                height: '30rem',
                top: '14%',
                right: '18.25%',
              }}
            >
              {carouselImages.length > 0 ? (
                carouselImages.map((src, idx) => {
                  if (src.file instanceof File || src.file instanceof Blob) {
                    return (
                      <Carousel.Item key={idx}>
                        <a
                          href={redirectUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className="d-flex"
                            src={URL.createObjectURL(src.file)}
                            alt={src.label}
                            style={{
                              objectFit: 'cover',
                              height: '30rem',
                            }}
                          />
                        </a>
                      </Carousel.Item>
                    )
                  }
                  if (typeof src.file === 'string') {
                    return (
                      <Carousel.Item key={idx}>
                        <a
                          href={redirectUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className="d-flex"
                            src={src.file}
                            alt={src.label}
                            style={{
                              objectFit: 'cover',
                              height: '30rem',
                            }}
                          />
                        </a>
                      </Carousel.Item>
                    )
                  }
                  return null
                })
              ) : (
                <Carousel.Item>
                  <div className="text-center p-3 text-muted">請上傳圖片</div>
                </Carousel.Item>
              )}
            </Carousel>
            <Button
              onClick={() => {
                setShowSecondImage(false)
                setShowSmallImage(true)
              }}
              style={{
                position: 'absolute',
                top: '15%',
                right: '19.5%',
                background: 'rgba(0, 0, 0, 0.5)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                fontSize: '14px',
                cursor: 'pointer',
                zIndex: '1501',
                padding: '0',
              }}
            >
              ✕
            </Button>
            <CIIcon bottom="6%" right="19%" />
          </>
        )}
      </div>
    </div>
  )
}

NoteCarouselPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  redirectUrl: PropTypes.string,
}

NoteCarouselPreview.defaultProps = {
  redirectUrl: '',
}

export default NoteCarouselPreview
